import React from 'react';
import { BookOpenIcon, StarIcon } from '@heroicons/react/24/outline';


const MyDailyAdventure = () => {
  const missions = [
    { task: 'Read Chapter 3 of "The Magical Treehouse"', due: 'Today', completed: false },
    { task: 'Complete Math Worksheet (Page 25)', due: 'Tomorrow', completed: false },
    { task: 'Draw a picture of your favorite animal', due: 'Completed!', completed: true },
  ];

  return (
    <div className="bg-white rounded-2xl p-6 shadow-glass border-b-4 border-indigo-600 transition-all duration-300 hover:shadow-xl hover:scale-[1.01]">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 flex items-center">
        <BookOpenIcon className="w-8 h-8 mr-3 text-indigo-600" />
        My Daily Adventure
      </h2>
      <div className="mb-6">
        <p className="text-lg text-gray-700 mb-2">
          Adventure Progress: <span className="font-semibold text-indigo-600">60% Complete!</span>
        </p>
        <div className="w-full bg-gray-100 rounded-full h-3 overflow-hidden">
          <div className="bg-indigo-600 h-3 rounded-full transition-all duration-500" style={{ width: '60%' }}></div>
        </div>
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-3 flex items-center">
        <StarIcon className="w-6 h-6 mr-2 text-orange-500" />
        Today's Missions
      </h3>
      <ul className="space-y-3">
        {missions.map((mission, index) => (
          <li
            key={index}
            className={`flex items-center bg-gray-50 p-4 rounded-lg shadow-sm hover:bg-gray-100 transition-all duration-200 ${
              mission.completed ? 'line-through opacity-70' : ''
            }`}
          >
            <input
              type="checkbox"
              className="h-5 w-5 mr-3 text-indigo-600 rounded-full focus:ring-indigo-500"
              checked={mission.completed}
              readOnly
            />
            <span className="text-lg text-gray-800 flex-grow">{mission.task}</span>
            <span className="ml-auto text-sm text-gray-500">{mission.due}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
export default MyDailyAdventure;